import * as React from "react";

function SvgWigzo(props, ref) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 530 327"
      xmlns="http://www.w3.org/2000/svg"
      {...{ ...props, ref }}
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M157.532 289.139l-99.877 37.53c-8.629-22.957-13.348-47.828-13.348-73.803H151c0 12.539 2.199 24.745 6.532 36.273"
          fill="#27A0D2"
        />
        <path
          d="M153.062 237.818L.764 231.525c.303-7.321.913-14.57 1.808-21.713C12.818 128.264 60.97 59.208 128.247 19.953L205.07 151.59c-28.506 16.638-47.188 44.778-51.264 77.213a104.125 104.125 0 00-.744 9.015"
          fill="#96CEE6"
        />
        <path
          d="M196.688 144.403L126.63 38.455a228.005 228.005 0 0112.725-7.827C173.048 11.367 212.066.378 253.645.426l-.129 127.012c-18.269-.019-35.474 4.515-51.126 13.461a102.224 102.224 0 00-5.702 3.504"
          fill="#27A0D2"
        />
        <path
          d="M260.741 125.341v-81.29c63.503 0 119.798 30.818 154.763 78.311l-65.458 48.192c-21.16-28.735-53.706-45.213-89.305-45.213M152.015 246.259H70.73c0-32.702 8.17-63.499 22.584-90.451l71.684 38.341c-8.612 16.104-12.983 33.635-12.983 52.11"
          fill="#E8F5FA"
        />
        <g fill="#27A0D2">
          <path d="M229.568 189.874l-4.288 87.433h3.597l37.212-86.024h11.62l-2.628 86.024h3.597l36.244-87.433h10.652l-41.225 97.429h-18.398l2.628-80.252-34.308 80.252H215.32l3.734-97.429h10.514zM332.91 216.906h10.375l-16.047 70.396h-10.237l15.909-70.396zm6.225-27.313h10.376l-2.905 12.671h-10.514l3.043-12.671zM338.859 301.945c0-10.7 10.236-17.317 18.26-21.541-1.383-1.408-2.213-3.238-2.213-6.055 0-6.194 7.608-13.656 7.608-13.656-6.226-2.957-9.545-8.308-9.545-16.896 0-13.517 9.96-28.3 27.806-28.3 7.193 0 13.28 2.253 13.28 2.253l20.474-.845-2.075 9.011h-12.312c1.244 2.112 2.352 5.209 2.352 9.715 0 12.53-9.822 27.736-29.189 27.736-1.937 0-4.564-.423-4.564-.423s-4.289 5.632-4.289 9.293c0 3.238 3.32 4.083 12.865 5.35 13.973 1.83 20.889 5.913 20.889 16.755 0 13.938-13.003 26.046-34.584 26.046-15.218.001-24.763-6.617-24.763-18.443zm23.656-17.881c-6.226 3.238-13.834 9.292-13.834 15.628 0 6.617 4.842 11.686 15.355 11.686 12.45 0 24.07-5.772 24.07-16.19 0-5.914-4.012-7.604-13.557-8.87-6.224-.705-10.098-1.549-12.034-2.254zm30.157-47.869c0-7.744-3.458-11.827-12.45-11.827-11.344 0-17.431 10.7-17.431 19.007 0 6.617 3.044 11.264 11.482 11.264 12.727 0 18.399-11.264 18.399-18.444zM422.416 216.906h47.173l-1.937 9.011-47.173 52.234h35.275l-2.075 9.151h-47.311l1.66-9.011 47.034-52.234h-34.86l2.214-9.151zM529.631 239.434c0 25.765-13.143 49.277-35.138 49.277-15.355 0-23.655-6.899-23.655-23.09 0-26.188 14.11-50.123 34.86-50.123 15.494 0 23.933 7.744 23.933 23.936zm-10.376-.142c0-8.729-4.288-14.642-13.557-14.642-14.802 0-24.485 19.992-24.485 41.111 0 8.87 4.427 13.798 13.28 13.798 15.217.001 24.762-19.148 24.762-40.267z" />
        </g>
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgWigzo);
